import ACCOUNT_ROLES from '../constants/account-roles';
import { ALBUM_TYPE, ALBUM_SUBTYPE } from '../constants/albums';
import { BASENAME } from '../constants/basenames';
import { CONTRIBUTOR_UPLOAD_ACCESS } from '../constants/contributors';

const definitions = {
  [BASENAME.PRO]: {
    roles: [ACCOUNT_ROLES.PHOTOGRAPHER],
    albumsFilter(album) {
      // Photographer / pro generic albums are of PRO type,
      // and have either a null subtype or YOUTH_SPORTS, WEDDINGS,
      // or EVENTS.
      return (
        album.album_type === ALBUM_TYPE.PRO.toUpperCase() &&
        (album.album_subtype == null ||
          album.album_subtype === ALBUM_SUBTYPE.YOUTH_SPORTS ||
          album.album_subtype === ALBUM_SUBTYPE.WEDDINGS ||
          album.album_subtype === ALBUM_SUBTYPE.EVENTS)
      );
    },
    defaultAlbumData: {
      is_paid: true,
      default_matches_only_setting: false,
    },
    defaultFolderData: {
      album_type: ALBUM_TYPE.PRO.toUpperCase(),
      album_subtype: null,
      default_matches_only_setting: false,
    },
    allowedContentTypes: [
      {
        album_type: ALBUM_TYPE.PRO,
        album_subtype: null,
      },
      {
        album_type: ALBUM_TYPE.PRO,
        album_subtype: ALBUM_SUBTYPE.YOUTH_SPORTS,
      },
      {
        album_type: ALBUM_TYPE.PRO,
        album_subtype: ALBUM_SUBTYPE.EVENTS,
      },
      {
        album_type: ALBUM_TYPE.EVENT,
        album_subtype: ALBUM_SUBTYPE.WEDDINGS,
      },
      {
        album_type: ALBUM_TYPE.PRO,
        album_subtype: ALBUM_SUBTYPE.EVENTS,
        web_app_basename: BASENAME.PRO.toUpperCase(),
      },
    ],
    // Empty string for Generic Pro albums
    allowedAlbumSubtypes: ['', ALBUM_SUBTYPE.YOUTH_SPORTS],
    allowedFolderSubtypes: [
      '',
      ALBUM_SUBTYPE.YOUTH_SPORTS,
      ALBUM_SUBTYPE.EVENTS,
      ALBUM_SUBTYPE.WEDDINGS,
    ],
  },
  [BASENAME.CAMPS]: {
    roles: [ACCOUNT_ROLES.CAMP_ADMIN],
    albumsFilter(album) {
      return (
        album.album_type === ALBUM_TYPE.CAMP.toUpperCase() ||
        (album.album_type === ALBUM_TYPE.PRO.toUpperCase() &&
          album.album_subtype === ALBUM_SUBTYPE.CAMPS.toUpperCase())
      );
    },
    defaultAlbumData: {
      is_paid: true,
      album_subtype: ALBUM_SUBTYPE.CAMPS.toUpperCase(),
      default_matches_only_setting: false,
    },
    defaultFolderData: {
      album_type: ALBUM_TYPE.PRO,
      album_subtype: ALBUM_SUBTYPE.CAMPS.toUpperCase(),
      default_matches_only_setting: false,
    },

    allowedContentTypes: [
      {
        album_type: ALBUM_TYPE.PRO,
        album_subtype: ALBUM_SUBTYPE.CAMPS,
      },
      {
        album_type: ALBUM_TYPE.PRO,
        album_subtype: ALBUM_SUBTYPE.EVENTS,
        web_app_basename: BASENAME.CAMPS.toUpperCase(),
      },
    ],
    allowedAlbumSubtypes: [ALBUM_SUBTYPE.CAMPS],
    allowedFolderSubtypes: [ALBUM_SUBTYPE.CAMPS],
  },
  [BASENAME.SCHOOLS]: {
    roles: [ACCOUNT_ROLES.SCHOOL_ADMIN],
    albumsFilter(album) {
      return (
        album.album_type === ALBUM_TYPE.PRO.toUpperCase() &&
        album.album_subtype === ALBUM_SUBTYPE.SCHOOLS.toUpperCase()
      );
    },
    defaultAlbumData: {
      is_paid: true,
      album_subtype: ALBUM_SUBTYPE.SCHOOLS.toUpperCase(),
      default_matches_only_setting: false,
      enable_external_upload: false,
    },
    defaultFolderData: {
      album_type: ALBUM_TYPE.PRO.toUpperCase(),
      album_subtype: ALBUM_SUBTYPE.SCHOOLS.toUpperCase(),
      default_matches_only_setting: false,
      enable_external_upload: false,
    },
    allowedContentTypes: [
      {
        album_type: ALBUM_TYPE.PRO,
        album_subtype: ALBUM_SUBTYPE.SCHOOLS,
      },
      {
        album_type: ALBUM_TYPE.PRO,
        album_subtype: ALBUM_SUBTYPE.EVENTS,
        web_app_basename: BASENAME.SCHOOLS.toUpperCase(),
      },
    ],
    allowedAlbumSubtypes: [ALBUM_SUBTYPE.SCHOOLS],
    allowedFolderSubtypes: [ALBUM_SUBTYPE.SCHOOLS],
  },
  [BASENAME.GREEK]: {
    roles: [ACCOUNT_ROLES.GREEK_ADMIN],
    albumsFilter(album) {
      return (
        album.album_type === ALBUM_TYPE.PRO.toUpperCase() &&
        album.album_subtype === ALBUM_SUBTYPE.GREEK.toUpperCase()
      );
    },
    defaultAlbumData: {
      is_paid: true,
      album_subtype: ALBUM_SUBTYPE.GREEK.toUpperCase(),
      default_matches_only_setting: false,
      enable_external_upload: true,
    },
    defaultFolderData: {
      album_type: ALBUM_TYPE.PRO.toUpperCase(),
      album_subtype: ALBUM_SUBTYPE.GREEK.toUpperCase(),
      default_matches_only_setting: false,
      auto_contributor_settings: {
        upload_access: CONTRIBUTOR_UPLOAD_ACCESS.REVIEW,
      },
      enable_external_upload: true,
    },
    allowedContentTypes: [
      {
        album_type: ALBUM_TYPE.PRO,
        album_subtype: ALBUM_SUBTYPE.GREEK,
      },
      {
        album_type: ALBUM_TYPE.PRO,
        album_subtype: ALBUM_SUBTYPE.EVENTS,
        web_app_basename: BASENAME.GREEK.toUpperCase(),
      },
    ],
    allowedAlbumSubtypes: [ALBUM_SUBTYPE.GREEK],
    allowedFolderSubtypes: [ALBUM_SUBTYPE.GREEK],
  },
  [BASENAME.EVENTS]: {
    roles: [ACCOUNT_ROLES.EVENT_ORGANIZER],
    albumsFilter(album) {
      return (
        album.album_type === ALBUM_TYPE.PRO.toUpperCase() &&
        (album.album_subtype == null ||
          album.album_subtype === ALBUM_SUBTYPE.WEDDINGS ||
          album.album_subtype === ALBUM_SUBTYPE.EVENTS.toUpperCase())
      );
    },
    defaultAlbumData: {
      is_paid: true,
      album_subtype: null,
      default_matches_only_setting: false,
      enable_external_upload: true,
    },
    defaultFolderData: {
      album_type: ALBUM_TYPE.PRO.toUpperCase(),
      album_subtype: null,
      default_matches_only_setting: false,
      auto_contributor_settings: {
        upload_access: CONTRIBUTOR_UPLOAD_ACCESS.REVIEW,
      },
      enable_external_upload: true,
    },
    allowedContentTypes: [
      {
        album_type: ALBUM_TYPE.PRO,
        album_subtype: null,
      },
      {
        album_type: ALBUM_TYPE.PRO,
        album_subtype: ALBUM_SUBTYPE.EVENTS,
        web_app_basename: BASENAME.EVENTS.toUpperCase(),
      },
      {
        album_type: ALBUM_TYPE.EVENT,
        album_subtype: ALBUM_SUBTYPE.WEDDINGS,
      },
    ],
    allowedAlbumSubtypes: [''],
    allowedFolderSubtypes: [''],
  },
  [BASENAME.RESORTS]: {
    roles: [ACCOUNT_ROLES.RESORT_ADMIN],
    albumsFilter(album) {
      return (
        album.album_type === ALBUM_TYPE.PRO.toUpperCase() &&
        album.album_subtype === ALBUM_SUBTYPE.RESORTS.toUpperCase()
      );
    },
    defaultAlbumData: {
      is_paid: true,
      album_subtype: ALBUM_SUBTYPE.RESORTS.toUpperCase(),
      default_matches_only_setting: false,
    },
    defaultFolderData: {
      album_type: ALBUM_TYPE.PRO.toUpperCase(),
      album_subtype: ALBUM_SUBTYPE.RESORTS.toUpperCase(),
      default_matches_only_setting: false,
    },
    allowedContentTypes: [
      {
        album_type: ALBUM_TYPE.PRO,
        album_subtype: ALBUM_SUBTYPE.RESORTS,
      },
      {
        album_type: ALBUM_TYPE.PRO,
        album_subtype: ALBUM_SUBTYPE.EVENTS,
        web_app_basename: BASENAME.RESORTS.toUpperCase(),
      },
    ],
    allowedAlbumSubtypes: [ALBUM_SUBTYPE.RESORTS],
    allowedFolderSubtypes: [ALBUM_SUBTYPE.RESORTS],
  },
  [BASENAME.SPORTS]: {
    roles: [ACCOUNT_ROLES.SPORTS_ADMIN],
    albumsFilter(album) {
      return (
        album.album_type === ALBUM_TYPE.PRO.toUpperCase() &&
        album.album_subtype === ALBUM_SUBTYPE.SPORTS.toUpperCase()
      );
    },
    defaultAlbumData: {
      is_paid: true,
      album_subtype: ALBUM_SUBTYPE.SPORTS.toUpperCase(),
      default_matches_only_setting: false,
    },
    defaultFolderData: {
      album_type: ALBUM_TYPE.PRO.toUpperCase(),
      album_subtype: ALBUM_SUBTYPE.SPORTS.toUpperCase(),
      default_matches_only_setting: false,
      is_web_gallery: true,
      is_private_web_gallery: true,
    },
    initialAlbumFolderSettings: {
      isWebGallery: true,
      isPrivateWebGallery: true,
    },
    allowedContentTypes: [
      {
        album_type: ALBUM_TYPE.PRO,
        album_subtype: ALBUM_SUBTYPE.SPORTS,
      },
      {
        album_type: ALBUM_TYPE.PRO,
        album_subtype: ALBUM_SUBTYPE.EVENTS,
        web_app_basename: BASENAME.SPORTS.toUpperCase(),
      },
    ],
    allowedAlbumSubtypes: [ALBUM_SUBTYPE.SPORTS],
    allowedFolderSubtypes: [ALBUM_SUBTYPE.SPORTS],
  },
  [BASENAME.CHURCH]: {
    roles: [ACCOUNT_ROLES.CHURCH_ADMIN],
    albumsFilter(album) {
      return (
        album.album_type === ALBUM_TYPE.PRO.toUpperCase() &&
        album.album_subtype === ALBUM_SUBTYPE.CHURCH.toUpperCase()
      );
    },
    defaultAlbumData: {
      is_paid: true,
      album_subtype: ALBUM_SUBTYPE.CHURCH.toUpperCase(),
      default_matches_only_setting: false,
    },
    defaultFolderData: {
      album_type: ALBUM_TYPE.PRO.toUpperCase(),
      album_subtype: ALBUM_SUBTYPE.CHURCH.toUpperCase(),
      default_matches_only_setting: false,
    },
    allowedContentTypes: [
      {
        album_type: ALBUM_TYPE.PRO,
        album_subtype: ALBUM_SUBTYPE.CHURCH,
      },
      {
        album_type: ALBUM_TYPE.PRO,
        album_subtype: ALBUM_SUBTYPE.EVENTS,
        web_app_basename: BASENAME.CHURCH.toUpperCase(),
      },
    ],
    allowedAlbumSubtypes: [ALBUM_SUBTYPE.CHURCH],
    allowedFolderSubtypes: [ALBUM_SUBTYPE.CHURCH],
  },
  [BASENAME.SHUTTERBUG]: {
    roles: [ACCOUNT_ROLES.SHUTTERBUG],
    albumsFilter(album) {
      return album.album_type === ALBUM_TYPE.SHUTTERBUG.toUpperCase();
    },
    defaultAlbumData: {
      album_type: ALBUM_TYPE.SHUTTERBUG,
      default_matches_only_setting: true,
    },
    defaultFolderData: {
      album_type: ALBUM_TYPE.SHUTTERBUG,
      album_subtype: null,
      default_matches_only_setting: true,
    },
    allowedContentTypes: [
      {
        album_type: ALBUM_TYPE.SHUTTERBUG,
        album_subtype: undefined,
      },
      {
        album_type: ALBUM_TYPE.EVENT,
        album_subtype: ALBUM_SUBTYPE.WEDDINGS,
      },
    ],
    // Empty string for Generic Shutterbug albums (no subtype)
    allowedAlbumSubtypes: [''],
    allowedFolderSubtypes: [''],
  },
};

/**
 * Given a basename it returns its definitions {@see definitions}.
 *
 * @param {BASENAME} basename - The basename.
 * @returns {Object} - The definitions that correspond to the basename provided.
 */
const getBasenameDefinitions = basename => {
  return definitions[basename];
};

/**
 * Given a PRO account role returns the first basename found for that role
 * from the basename `definitions` {@see definitions}.
 *
 * @param {ACCOUNT_PRO_ROLES} role - The account role.
 * @returns {BASENAME} - The first basename that corresponds to the account role given.
 */
const getRoleBasename = role => {
  return Object.keys(definitions).find(key => {
    const definition = definitions[key];
    return definition.roles.includes(role);
  });
};

/**
 * Given a basename returns the album filter for that basename.
 *
 * @param {BASENAME} basename - The basename.
 * @returns {albumsFilter|(function(*): boolean)} - The album filter.
 */
const getBasenameAlbumFilter = basename => {
  const basenameDefs = getBasenameDefinitions(basename);

  if (!basenameDefs) {
    throw Error(
      `Basename definitions were not found, are you sure you provided a valid basename? Provided: ${basename}`,
    );
  }

  return basenameDefs.albumsFilter || (() => false);
};

/**
 * Given a basename returns the available account roles for
 * that basename.
 *
 * @param {BASENAME} basename - The basename.
 * @returns {Array<ACCOUNT_ROLES>} - The account roles that correspond to the supplied basename.
 */
const getRolesByBasename = basename => {
  const basenameDefs = definitions[basename];

  if (!basenameDefs || !basenameDefs.roles) {
    return undefined;
  }

  return basenameDefs.roles;
};

/**
 * Returns an array of all valid role basenames.
 * Mainly used for prop type validation.
 *
 * @returns {Array} - The basenames.
 */
const getProductBasenames = () => {
  return Object.values(BASENAME);
};

/**
 * Gets the allowed album subtypes a basename can render/show.
 *
 * @param {BASENAME} basename - The basename.
 * @returns {Array<ALBUM_SUBTYPE>} - The allowed subtypes.
 */
const getAllowedAlbumSubTypesByBasename = basename => {
  if (!basename) {
    return [];
  }

  const basenameDefs = getBasenameDefinitions(basename);
  return basenameDefs.allowedAlbumSubtypes || [];
};

/**
 * Gets the allowed album folder subtypes a basename can render/show.
 *
 * @param {BASENAME} basename - The basename.
 * @returns {Array<ALBUM_SUBTYPE>} - The allowed subtypes.
 */
const getAllowedFolderSubTypesByBasename = basename => {
  if (!basename) {
    return [];
  }

  const basenameDefs = getBasenameDefinitions(basename);
  return basenameDefs.allowedFolderSubtypes || [];
};

/**
 * Given a basename it figures out what the optimal album type
 * should be for that basename. Used for contextual strings.
 *
 * @param {string} basename - A valid {@see BASENAME}.
 * @returns {string|null} - The album type.
 */
const getAlbumTypeOnBasename = basename => {
  if (!basename || !Object.values(BASENAME).includes(basename)) {
    return null;
  }

  if (basename === BASENAME.SHUTTERBUG) {
    return ALBUM_TYPE.SHUTTERBUG;
  }

  return ALBUM_TYPE.PRO;
};

/**
 * Given a basename it figures out what the optimal album subtype
 * should be for that basename. Used for contextual strings.
 *
 * @param {string} basename - A valid {@see BASENAME}.
 * @returns {string|null} - The assigned album subtype.
 */
const getAlbumSubtypeOnBasename = basename => {
  if (!basename || !Object.values(BASENAME).includes(basename)) {
    return null;
  }

  const basenameToAlbumSubtype = {
    [BASENAME.PRO]: null,
    [BASENAME.CAMPS]: ALBUM_SUBTYPE.CAMPS,
    [BASENAME.SCHOOLS]: ALBUM_SUBTYPE.SCHOOLS,
    [BASENAME.RESORTS]: ALBUM_SUBTYPE.RESORTS,
    [BASENAME.GREEK]: ALBUM_SUBTYPE.GREEK,
    [BASENAME.SPORTS]: ALBUM_SUBTYPE.SPORTS,
    [BASENAME.CHURCH]: ALBUM_SUBTYPE.CHURCH,
  };

  return basenameToAlbumSubtype[basename] || null;
};

/**
 * Returns, based on the album or albumFolder, which basename they should belong to.
 *
 * @param {Album|AlbumFolder} entity The entity to check for.
 */
const getBasenameFromEntity = entity => {
  if (!entity) {
    return undefined;
  }

  if (
    entity.album_type === ALBUM_TYPE.SHUTTERBUG ||
    entity.album_type === ALBUM_TYPE.EVENT
  ) {
    return BASENAME.SHUTTERBUG;
  }

  const albumSubtypeToBasename = {
    [ALBUM_SUBTYPE.RESORTS]: BASENAME.RESORTS,
    [ALBUM_SUBTYPE.SCHOOLS]: BASENAME.SCHOOLS,
    [ALBUM_SUBTYPE.YOUTH_SPORTS]: BASENAME.YOUTH_SPORTS,
    [ALBUM_SUBTYPE.CAMPS]: BASENAME.CAMPS,
    [ALBUM_SUBTYPE.WEDDINGS]: BASENAME.PRO,
    [ALBUM_SUBTYPE.EVENTS]: BASENAME.PRO,
    [ALBUM_SUBTYPE.GREEK]: BASENAME.GREEK,
    [ALBUM_SUBTYPE.SPORTS]: BASENAME.SPORTS,
    [ALBUM_SUBTYPE.CHURCH]: BASENAME.CHURCH,
  };

  return albumSubtypeToBasename[entity.album_subtype] || BASENAME.PRO;
};

export {
  getBasenameDefinitions,
  getRoleBasename,
  getProductBasenames,
  getRolesByBasename,
  getAllowedAlbumSubTypesByBasename,
  getAllowedFolderSubTypesByBasename,
  getAlbumSubtypeOnBasename,
  getBasenameAlbumFilter,
  getAlbumTypeOnBasename,
  getBasenameFromEntity,
};
